<template>
  <div class="preview-field">
    <DpplSafeHtml
      v-if="html"
      :html="html"
    />
    <slot />
  </div>
</template>

<script setup>
import DpplSafeHtml from '@ui/components/general/DpplSafeHtml/DpplSafeHtml.vue';

defineProps({
  html: { type: String, default: '' },
});
</script>

<style scoped lang="less">
.preview-field {
  font-size: 12px;
  font-weight: 500;
  color: fade(@text-darkest, 75%);

  :deep(p) {
    font-size: 12px;
    font-weight: 500;
  }

  :deep(section), :deep(article) {
    font-size: 12px;
    font-weight: 500;
  }

  :deep(span) {
    font-weight: 300;
  }

  :deep(strong), :deep(b) {
    font-weight: 700;
  }

  :deep(h1), :deep(h2), :deep(h3) {
    font-weight: bold;
    line-height: 30px;
  }

  :deep(h3) {
    font-size: 12px;
  }

  :deep(h2) {
    font-size: 13px;
  }

  :deep(h1) {
    font-size: 14px;
  }

  :deep(> ul), :deep(> ol) {
    margin-left: 16px;
    ul, ol {
      padding-left: 12px;
    }
  }

  :deep(ul), :deep(ol) {
    li {
      padding-right: 0;
    }
  }

  :deep(ul) li::marker {
    unicode-bidi: isolate;
    font-variant-numeric: tabular-nums;
    text-transform: none;
    text-indent: 0px !important;
    text-align: start !important;
    text-align-last: start !important;
  }
}
</style>
